import PropTypes from 'prop-types';

export const props = {
  link: PropTypes.string,
  text: PropTypes.string,
  isActive: PropTypes.bool,
};
